import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.tsx';
import ProtectedRoute from './components/ProtectedRoute.tsx';
import PermissionRoute from './components/PermissionRoute.tsx';
import Navbar from './components/Navbar.tsx';
import Dashboard from './pages/Dashboard.tsx';
import ItemKits from './pages/ItemKits.tsx';
import AddItemKit from './pages/AddItemKit.tsx';
import ViewItemKit from './pages/ViewItemKit.tsx';
import Items from './pages/Items.tsx';
import Users from './pages/Users.tsx';
import './App.css';
import EditItemKit from './pages/EditItemKit.tsx';
import DashboardHome from './pages/DashboardHome.tsx';
import EditItem from './pages/EditItem.tsx';
import EditUser from './pages/EditUser.tsx';
import Login from './pages/Login.tsx';
import Countries from './pages/Countries.tsx';
import EditCountry from './pages/EditCountry.tsx';
import AddCountry from './pages/AddCountry.tsx';
import States from './pages/States.tsx';
import AddState from './pages/AddState.tsx';
import EditState from './pages/EditState.tsx';
import Retailers from './pages/Retailers.tsx';
import AddRetailer from './pages/AddRetailer.tsx';
import EditRetailer from './pages/EditRetailer.tsx';
import DeliveryAddresses from './pages/DeliveryAddresses.tsx';
import AddDeliveryAddress from './pages/AddDeliveryAddress.tsx';
import EditDeliveryAddress from './pages/EditDeliveryAddress.tsx';
import ReportedPosts from './pages/ReportedPosts.tsx';
import Support from './pages/Support.tsx';
import SearchAnalytics from './pages/SearchAnalytics.tsx';
import PerformanceAnalytics from './pages/PerformanceAnalytics.tsx';
import UserActivity from './pages/UserActivity.tsx';
import Roles from './pages/Roles.tsx';
import SuperUsers from './pages/SuperUsers.tsx';

function App() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const toggleSidebar = () => {
    if (window.innerWidth <= 768) {
      setIsMobileOpen(prev => !prev);
    } else {
      setIsSidebarCollapsed(prev => !prev);
    }
  };

  const closeMobileSidebar = () => {
    setIsMobileOpen(false);
  };

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <>
                    <Navbar 
                      isCollapsed={isSidebarCollapsed} 
                      toggleSidebar={toggleSidebar} 
                    />
                    <Routes>
                      <Route path="/dashboard/*" element={<Dashboard isCollapsed={isSidebarCollapsed} isMobileOpen={isMobileOpen} onMobileClose={closeMobileSidebar} />} />
                    </Routes>
                  </>
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
